import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';
import { createAuthGuard, AuthGuardData } from 'keycloak-angular';

export const KeycloakGuard = createAuthGuard(
  async (route, state, authData: AuthGuardData): Promise<boolean | UrlTree> => {
    const router = inject(Router);
    const keycloak = inject(Keycloak);
    const translate = inject(TranslateService);
    const realm = localStorage.getItem('realm');

    if (!realm) {
      return router.parseUrl('/auth/select-keycloak-realm');
    }

    if (!authData.authenticated) {
      await keycloak.login({
        redirectUri: window.location.origin + '/auth/select-company',
        locale: translate.getCurrentLang() ?? 'tr',
      });
      return false;
    }

    return true;
  }
);
